export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YK5silQs6yLUrwB0lw.cc9829b2.woff2";